import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '@/api/axios';

const SettingsContext = createContext();

// Local logo path - this will work in both preview and deployed environments
const LOCAL_LOGO_PATH = '/logo.png';

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    company_name: 'Noble Shield',
    logo_url: LOCAL_LOGO_PATH
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await api.get('/settings');
      // Ensure logo_url falls back to local logo if not set or using external URL
      const fetchedSettings = response.data;
      if (!fetchedSettings.logo_url || fetchedSettings.logo_url.includes('customer-assets.emergentagent.com')) {
        fetchedSettings.logo_url = LOCAL_LOGO_PATH;
      }
      setSettings(fetchedSettings);
    } catch (error) {
      console.error('Failed to fetch settings:', error);
      // Use default settings on error
    } finally {
      setLoading(false);
    }
  };

  const updateSettings = async (newSettings) => {
    try {
      const response = await api.put('/settings', newSettings);
      setSettings(response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to update settings:', error);
      throw error;
    }
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, updateSettings, refreshSettings: fetchSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};
